import React from "react";
import { Label } from "reactstrap";
import { WeeklyCalendar } from "react-week-picker";
import "./weekpicker.css";

const WeekPicker = ({ value, onChange, label = "Week", className = "" }) => {
  const handleJumpToCurrentWeek = (currenDate) => {
  };

  const handleWeekPick = (startDate, endDate) => {
    onChange(startDate, endDate);
  };

  return (
    <div className={`col-md-12 col-sm-12 ${className} weekpicker`}>
      <Label>{label}</Label>
      <WeeklyCalendar
        onWeekPick={handleWeekPick}
        jumpToCurrentWeekRequired={false}
        onJumpToCurrentWeek={handleJumpToCurrentWeek}
      />
    </div>
  );
};

export default WeekPicker;
